import React from "react";
import SaveAsDialog from "../SaveAsDialog/SaveAsDialog";
import { useCloneSegmentDialog } from "./CloneSegmentDialog.hooks";

export interface CloneSegmentDialogProps {
  segmentId?: string;
  name?: string;
  open: boolean;
  onClose: () => void;
  onSuccess: (newId: string) => void;
}

function CloneSegmentDialog(props: CloneSegmentDialogProps) {
  const {
    saveAs,
    saveErrorMessage,
    saving,
    closeErrorMessage,
    open,
    onClose,
    name,
    reset,
  } = useCloneSegmentDialog(props);

  return (
    <SaveAsDialog
      open={open}
      onClose={onClose}
      onSave={saveAs}
      onExit={reset}
      title="Save segment as"
      inputLabel="Segment name"
      name={name}
      errorMessage={saveErrorMessage}
      onErrorMessageClose={closeErrorMessage}
      saving={saving}
      maxLength={140}
    />
  );
}

export default CloneSegmentDialog;
